export default "__VITE_ASSET__CMVuPpET__"